import { useCallback, useEffect, useRef } from "react";

function useHandleRefElement() {
  const currentElement = useRef<any>();
  const programObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        currentElement?.current?.setAttribute('tabindex', entry.isIntersecting ? 0 : -1);
      });
    },
    {
      rootMargin: '100px -100px 100px -200px', // gap in the viewport
    }
  );

  useEffect(() => {
    return () => {
      programObserver.disconnect();
    };
  }, []);

  return useCallback((node: any) => {
    if (node) {
      currentElement.current = node;
      programObserver.observe(node);
    }
  }, [])
}

export {useHandleRefElement};
